/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RoleListResponse } from './RoleListResponse';

export type RoleListResponseApiRespoonse = {
    data?: RoleListResponse;
    status?: RoleListResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace RoleListResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

